// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const environmentCommonValues = {
  status: {
    draft: "下書き",
    active: "有効",
    published: "公開済み",
    archived: "アーカイブ",
    disabled: "無効",
  },
  visibility: {
    private: "非公開",
    shared: "共有",
  },
  values: {
    undefinedBoolean: "未定義の真偽値",
  },
  usageTypes: {
    target_device: "検証対象デバイス",
    template_source: "テンプレート元",
  },
  architectures: {
    x86_64: "x86_64",
    arm64: "ARM64",
    i386: "i386",
    other: "その他",
  },
} as const;
